$('.product_main_view').slick({
  autoplay: true, //自動再生
  autoplaySpeed: 3000, //自動再生の速度
  arrows: true, //前へ・次への矢印ナビを表示
  dots: true, //ドット型のナビを表示
  infinite: true //無限ループ
});